export default __webpack_public_path__ + "static/media/Hammam-and-the-Royal-Bath.3fc68f87.jpg";